
<template>
  <!--格式化表格中的cell，因为有些数据比较难格式化，如枚举，和需子表查询，如通过id显示名字-->
<div>
  <div v-if="addSimpleFormName">
    <el-button v-on:click="showDialog(addSimpleFormName,'新增','ADD')" v-bind:text="true" size="small">新增</el-button>
  </div>
  <div style="padding: 10px 0;" v-if="isFilter">
    过滤：<el-input v-model="queryParams.filter" placeholder="输入关键字进行过滤" size="small" clearable style="width: 200px;" v-on:keyup="filterCellValue()"></el-input>
  </div>
  <el-table
      v-bind:border="true"
      v-bind:data="formuiTableRowFilterList"
      style="width: 100%">
    <el-table-column v-for="(fieldItem,fieldIndex) in formuiFieldList"
                     v-bind:label="fieldItem.title" :key="fieldItem.id">
      <template v-slot:default="scope">
        <slot
            v-bind:name="'cell_'+fieldItem.name"
            v-bind:value="scope.row.tableCellList[fieldIndex].value"
            v-bind:formatValue="scope.row.tableCellList[fieldIndex].formatValue">
          {{scope.row.tableCellList[fieldIndex].formatValue}}
        </slot>
      </template>
    </el-table-column>
    <el-table-column
        v-if="isMenu"
        fixed="right"
        label="操作">
      <template v-slot:default="scope">
        <slot name="menu" v-bind:scope="scope.row">
        </slot>
        <el-button v-if="editSimpleFormName" v-on:click="showDialog(editSimpleFormName,'编辑','EDIT',scope.row.id)" v-bind:text="true" size="small">编辑</el-button>
        <el-button v-if="deleteSimpleFormName" v-on:click="checkDel(scope.row.id)" v-bind:text="true" size="small">删除</el-button>
      </template>
    </el-table-column>
  </el-table>
  <el-pagination
      layout="prev, pager, next"
      v-bind:total="page.rsCount"
      v-bind:page-size="page.pageSize"
      v-bind:current-page="parseInt(queryParams.pageNo)+1"
      v-on:current-change="handleCurrentChange">
  </el-pagination>


  <div class="table-dialog" v-if="showSimpleForm==1">


    <FormUiSimpleTableFormDialog
        v-if="showSimpleForm==1"
        v-bind:formData="{id:simpleFormId}"
        v-bind:tableName="formTableName"
        v-bind:runType="formRunType"
        v-bind:title="simpleFormTitle"
        v-bind:autoSubmit="simpleFormAutoSubmit"
        v-on:closeDialog="closeDialog"
        v-on:submitCallback="submitCallback">
    </FormUiSimpleTableFormDialog>
  </div>
</div>
</template>
<script>

import formuiService from './service/formui/FormuiService'
import ossService from './service/base/OssService'
import FormUiSimpleTableFormDialog from './FormUiSimpleTableFormDialog.vue'

import formuiConfig from './formuiConfig'

export default {
  props: {
    methodName: String,
    isMenu: {
      type: Boolean,
      default: false
    },
    isFilter: {
      type: Boolean,
      default: false
    },
    editSimpleFormName: String,
    deleteSimpleFormName: String,
    addSimpleFormName: String,
    pageSize: {
      type: Number,
      default: 20
    }
  },
  components:{FormUiSimpleTableFormDialog},
  data() {
    return {
      simpleFormPath: '',
      formuiFieldList: [],
      formuiTableRowList: [],
      formuiTableRowFilterList: [],
      routeQuery: this.$route.query,
      page: { rsCount: 0, pageNo: 0, pageSize: 0 },
      queryParams: {},
      showSimpleForm: 0,
      simpleFormName: '',
      simpleFormTitle: '',
      simpleFormAutoSubmit: false,
      formTableName: '',
      formRunType: ''
    }
  },
  created() {
    this.simpleFormPath = formuiConfig.simpleFormPath
  },
  mounted() {
    this.queryParams['pageNo'] = 0
    this.queryParams['pageSize'] = this.pageSize

    Object.keys(this.$route.query).forEach(key => {
      this.queryParams[key] = this.$route.query[key]
    })

    ossService.initOssUrl(this,this.loadData)
  },
  beforeRouteUpdate(to) {
    this.queryParams.pageNo = to.query.pageNo
    this.loadData()
  },
  methods: {
    handleCurrentChange(data) {
      this.queryParams.pageNo = data - 1
      this.goByParam()
    },
    goByParam() {
      delete this.queryParams.methodName
      this.$router.push({
        query: this.queryParams
      })
    },
    loadData(queryParamsUpdate) {
      if (this,this.$route.query['methodName'] && this.$route.query['methodName'] !== this.methodName) {
        alert('你使用了受保护参数methodName:' + this.$route.query['methodName'])
        return
      }

      if (queryParamsUpdate) {
        this.queryParams = queryParamsUpdate
      }

      this.queryParams['methodName'] = this.methodName

      formuiService.getFormUiTable(this,this.queryParams, (resp) => {
        if (resp) {
          this.formuiFieldList = resp.formuiFieldList
          this.formuiTableRowList = resp.formuiTableRowList
          this.page = resp.page
          this.filterClear()
        }
      }, (err) => {})
    },
    filterClear() {
      for (let i = 0; i < this.formuiTableRowList.length; i++) {
        if (typeof this.formuiTableRowList[i]['isShow'] === 'undefined') {
          this.formuiTableRowList[i].isShow = true
        }
        if (!this.formuiTableRowList[i].isShow && this.formuiTableRowList[i].isShow === false) {
          this.formuiTableRowList[i].isShow = true
        }
      }
      this.formuiTableRowFilterList = this.formuiTableRowList
    },
    filterCellValue() {
      if (!this.queryParams.filter) {
        this.filterClear()
        return
      }
      let filterArr = this.queryParams.filter.split(' ')
      console.log('filter:', filterArr)
      this.formuiTableRowFilterList = []
      for (let i = 0; i < this.formuiTableRowList.length; i++) {
        let showNum = 0
        outj:
        for (let k = 0; k < filterArr.length; k++) {
          if (filterArr[k] === '') {
            showNum++
            continue outj
          }
          for (let j = 0; j < this.formuiFieldList.length; j++) {
            if (this.formuiTableRowList[i].tableCellList[j].formatValue.indexOf(filterArr[k]) !== -1) {
              showNum++
              continue outj
            }
          }
        }
        if (showNum === filterArr.length) {
          this.formuiTableRowFilterList.push(this.formuiTableRowList[i])
        }
      }
    },
    checkDel(rowId) {
      if (confirm('确认删除?') === false) {
        return false
      }
      this.simpleFormAutoSubmit = true
      this.showSimpleForm = 1
      this.simpleFormTitle = '删除'
      this.formRunType = 'DELETE'
      this.formTableName = this.methodName
      if (!rowId) {
        console.error('异常，无id')
        return
      } else {
        this.simpleFormId = rowId
      }
      this.simpleFormName = this.deleteSimpleFormName
    },
    showDialog(formName, title, formRunType, rowId) {
      this.simpleFormAutoSubmit = false
      this.showSimpleForm = 1
      this.simpleFormName = formName
      this.simpleFormTitle = title
      this.formTableName = this.methodName
      this.formRunType = formRunType
      if (!rowId) {
        this.simpleFormId = null
      } else {
        this.simpleFormId = rowId
      }
    },
    closeDialog() {
      console.log('closeDialog---------------------')
      this.showSimpleForm = 0
    },
    submitCallback() {
      console.log('submitCallback---------------------')
      this.loadData()
    }
  }
}
</script>


// WEBPACK FOOTER //
// node_modules/formui-vue2-vistastory/FormUiTable.vue